export default "__VITE_ASSET__d4m8kkht__"